<template>
  <v-navigation-drawer
    v-model="drawer"
    :width="width"
    location="right"
    temporary
    :disable-route-watcher="true"
  >
    <template v-slot:prepend>
      <div class="top px-3">
        <div class="green">
          <v-icon icon="mdi-check-circle-outline" class="icon mr-1"></v-icon
          >Added to Cart
        </div>
        <v-icon
          class="close"
          icon="mdi-close"
          size="22"
          @click="close"
        ></v-icon>
      </div>
      <div class="loading-mask" v-if="!loading">
        <shopmall-text-loading />
      </div>
      <div class="mt-5 cart">
        <v-row no-gutters>
          <v-col cols="3">
            <div class="img-wrap ml-5">
              <img
                v-if="cartObject?.productPicUrl"
                :src="
                  cartObject.productPicUrl + '?x-oss-process=image/resize,l_300'
                "
                alt
              />
            </div>
          </v-col>
          <v-col cols="9">
            <div class="pl-5" v-if="loading">
              <shopmall-item-quantity
                :show-sample="false"
                :detail="true"
                :product="cartObject"
              ></shopmall-item-quantity>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>

    <div class="footer w-100 px-5">
      <v-btn class="w-100" color="blue" @click="goCart">Go To Cart</v-btn>
      <p class="text-center pointer fs-14 my-5 fc-blue" @click="close">
        Continue Shopping
      </p>
    </div>
  </v-navigation-drawer>
</template>

<script setup>
import { cartInteractor } from "~/core";
import { useCartStore } from "~/stores";

const props = defineProps({
  width: {
    type: Number,
    default: 560
  }
});
const emit = defineEmits(["drawer-close"]);
const { $Message } = useNuxtApp();
const cartStore = useCartStore();
const cartObject = ref({});
const drawer = ref(false);
const loading = ref(false);
const route = useRoute();

// id:产品id
const show = async id => {
  drawer.value = !drawer.value;

  const list = await getCartList();

  cartObject.value = list.find(item => item.productId === id);
  loading.value = true;
};

const getCartList = async () => {
  let list = [];

  const [res, err] = await cartInteractor.listCartDetailApi();
  if (res) {
    if (Array.isArray(res)) {
      res.forEach(item => {
        item.imprintLabel = useProduct().getImprintLabel([
          item?.productPrinting?.printingConditions
        ]);
        if (
          item?.productInfo?.shelfStatus === 0 &&
          item.productPicValid &&
          item.productPrinting.printingValid &&
          !item.printingSwitchInvalid
        ) {
          if (item.productPrinting.printingColors) {
            item.productPrinting.printingColorsList =
              item.productPrinting.printingColors.split(",");
          }
          list.push(item);
        }
      });
    }
    return list || [];
  } else {
    return [];
  }
};

const goCart = () => {
  const htmlEl = document.querySelector("html");
  htmlEl.style.overflowY = "auto";
  navigateTo({
    path: "/my-cart",
    query: route.query
  });
};

const close = () => {
  drawer.value = false;
};

// 使用watch监听drawer
watch(
  () => drawer.value,
  val => {
    const htmlEl = document.querySelector("html");
    if (!val) {
      htmlEl.style.overflowY = "auto";
    } else {
      htmlEl.style.overflowY = "hidden";
    }
  }
);

defineExpose({
  show
});
</script>

<style lang="scss" scoped>
.drawer-content {
  height: calc(100% - 40px);
  overflow-y: auto;
}
.top {
  height: 49px;
  line-height: 49px;
  border-bottom: 1px solid #ddd;
  position: relative;
  .green {
    color: #4caf50;
  }
  .icon {
    margin-top: -3px;
  }
  .close.v-icon {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
}
.cart {
  .img-wrap {
    border: 1px solid #eee;
    img {
      width: 100%;
    }
  }
}
.footer {
  position: fixed;
  bottom: 0;
}
.loading-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba($color: #fff, $alpha: 0.7);
  z-index: 99;
}
</style>
